import { LineOrientation } from '../models/interfaces';
import { TableKey } from '../models/extraction-models/extraction-models';
import { WritableSignal } from '@angular/core';
import { WordRect } from '@ps-gui/claims-terminal-shared';

export type TableOverlayLine = Readonly<{
  orientation: LineOrientation;
  offset: WritableSignal<number>;
  isBoundary?: boolean;
}>;

export type TableData = Readonly<{
  tableModelKey: TableKey;
  id: string;
  pageId: string;

  confirmed: WritableSignal<boolean>;
  layoutDefined: WritableSignal<boolean>;
  lines: {
    vertical: WritableSignal<TableOverlayLine[]>;
    /**
     * offset 0 is top of page, 1 is bottom
     */
    horizontal: WritableSignal<TableOverlayLine[]>;
  };
  columnHeaders: WritableSignal<(string | undefined)[]>;
}>;

export const getFullTableRect = (table: TableData) =>
  getTableRect(
    table,
    0,
    // #columns = #lines.vertical - 1
    // index of last column = #columns - 1
    table.lines.vertical().length - 2,
    0,
    // #rows = #lines.vertical - 1
    // index of last row = #rows - 1
    table.lines.horizontal().length - 2,
  );

export const getTableRowRect = (table: TableData, rowIndex: number) =>
  getTableRect(
    table,
    0,
    // see getFullTableRect
    table.lines.vertical().length - 2,
    rowIndex,
    rowIndex,
  );

export const getTableRect = (
  table: TableData,
  fromColumnIndex: number,
  toColumnIndex: number,
  fromRowIndex: number,
  toRowIndex: number,
) => {
  const lines = table.lines;
  const xStart = lines.vertical()[fromColumnIndex].offset();
  const xEnd = lines
    .vertical()
    .at(toColumnIndex + 1)!
    .offset();
  const yStart = lines.horizontal()[fromRowIndex].offset();
  const yEnd = lines.horizontal()[toRowIndex + 1].offset();
  return {
    x: [xStart, xEnd] as const,
    y: [yStart, yEnd] as const,
  };
};

export const getTableCellWordRect = (
  table: TableData,
  columnIndex: number,
  rowIndex: number,
): WordRect => {
  const lines = table.lines;
  const [xStart, xEnd] = [
    lines.vertical()[columnIndex].offset(),
    lines.vertical()[columnIndex + 1].offset(),
  ];
  const [yStart, yEnd] = [
    lines.horizontal()[rowIndex].offset(),
    lines.horizontal()[rowIndex + 1].offset(),
  ];

  return {
    x: [xStart, xEnd],
    y: [yStart, yEnd],
  };
};
